class UserFront {
  constructor({
    userId = null,
    firstName = null,
    lastName = null,
    title = null,
    position = null,
    phone = null,
    email = null,
    securityStamp = null,
    twoFactorEnabled = null,
    userName = null,
    passwordHash = null,
    companyId = null,
    employeeId = null,
    privilegeLevel = null,
    status = null,
    value1 = null,
    remoteId = null,
    isnew = false,
  }) {
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.title = title;
    this.position = position;
    this.phone = phone;
    this.email = email;
    this.securityStamp = securityStamp;
    this.twoFactorEnabled = twoFactorEnabled;
    this.userName = userName;
    this.passwordHash = passwordHash;
    this.companyId = companyId;
    this.employeeId = employeeId;
    this.privilegeLevel = privilegeLevel;
    this.status = status;
    this.value1 = value1;
    this.remoteId = remoteId;
    this.isnew = isnew;
  }
}

class UserBack {
  constructor({
    userId = null,
    firstName = null,
    lastName = null,
    title = null,
    position = null,
    phone = null,
    email = null,
    securityStamp = null,
    twoFactorEnabled = false,
    userName = null,
    passwordHash = null,
    companyId = null,
    employeeId = null,
    privilegeLevel = null,
    status = null,
    value1 = null,
    remoteId = null,
    shouldRegenerateCredentials = null,
  }) {
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.title = title;
    this.position = position;
    this.phone = phone;
    this.email = email;
    this.securityStamp = securityStamp;
    this.twoFactorEnabled = twoFactorEnabled;
    this.userName = userName;
    this.passwordHash = passwordHash;
    this.companyId = companyId;
    this.employeeId = employeeId;
    this.privilegeLevel = privilegeLevel;
    this.status = status;
    this.value1 = value1;
    this.remoteId = remoteId;
    this.shouldRegenerateCredentials = shouldRegenerateCredentials;
  }
}

export { UserBack, UserFront };
